import request from "@/utils/request";
import plaintextrequest from "@/utils/plaintextrequest";

//抽奖者信息
export function userInfo(data) {
  // console.log('传递的token-----------------------',data)
  return request({
    url: "/Invitation/cjinfo",
    method: "post",
    data,
  });
}

// 开始抽奖
export function startLottery(data) {
  // console.log('传递的token',data)
  return request({
    url: "/Invitation/cjgetgift",
    method: "post",
    data,
  });
}

// 抽奖信息
export function lotteryInfo(data) {
  // console.log('传递的token',data)
  return plaintextrequest({
    url: "/publicH5/getcjinfo",
    method: "post",
    data,
  });
}
